<template>
  <button
    v-tooltip="{
      content: $t('SIDEBAR.PROFILE_SETTINGS'),
      placement: tooltipPlacement,
    }"
    :aria-label="$t('SIDEBAR.PROFILE_SETTINGS')"
    :aria-expanded="isMenuOpen ? 'true' : 'false'"
    class="flex items-center justify-center w-11 h-11 md:w-10 md:h-10 rounded-full outline-none ring-1 transition-shadow duration-200 ease-out focus-visible:ring-2 focus-visible:ring-accent-mint/70 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-ink"
    :class="
      isMenuOpen
        ? 'ring-accent-mint'
        : 'ring-slate-100 hover:ring-slate-300 dark:ring-white/[0.08] dark:hover:ring-white/20'
    "
    @click="handleClick"
  >
    <thumbnail
      :src="currentUser.avatar_url"
      :username="currentUser.name"
      :status="statusOfAgent"
      should-show-status-always
      size="32px"
    />
  </button>
</template>
<script>
import { mapGetters } from 'vuex';
import rtlMixin from 'shared/mixins/rtlMixin';
import Thumbnail from '../../widgets/Thumbnail.vue';

export default {
  components: {
    Thumbnail,
  },
  mixins: [rtlMixin],
  props: {
    isMenuOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      currentUserAvailability: 'getCurrentUserAvailability',
    }),
    statusOfAgent() {
      return this.currentUserAvailability || 'offline';
    },
    // Placement is a directive option, not a class, so no logical property can flip it
    // for RTL — the rail lives on the right there and `right` would open off-canvas.
    tooltipPlacement() {
      return this.isRTLView ? 'left' : 'right';
    },
  },
  methods: {
    handleClick() {
      this.$emit('toggle-menu');
    },
  },
};
</script>
